import { createActionGroup, props } from '@ngrx/store';
import { MachineDoc } from '@models';

export const DocsActions = createActionGroup({
  source: 'Docs',
  events: {
    'Load Doc': props<{ projectId: string; key: string }>(),
    'Load Doc Started': props<{ projectId: string; key: string }>(),
    'Apply Local Data': props<{ projectId: string; key: string; data: any }>(),
    'Load Doc Succeeded': props<{ projectId: string; key: string; doc: MachineDoc | null }>(),
    'Load Doc Failed': props<{ projectId: string; key: string; error: string }>(),
    'Save Doc': props<{ projectId: string; key: string; data: any }>(),
    'Save Doc Succeeded': props<{ projectId: string; key: string; doc: MachineDoc }>(),
    'Save Doc Failed': props<{ projectId: string; key: string; error: string }>(),
    'Clear Project': props<{ projectId: string }>(),
  },
});
